import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonType, ExpressionFunctionType } from '@iotv/iotv-v3-types';
import { TextField, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeByAttribute = (props) => {
    const { updateParams: setParamsInParent, keyPress, lastQuery, lastQueryParamsRef, index, type, attKey, children, selected } = props;
    const [params, setParams] = useState(lastQuery ?? { type, attKey, value: '' });
    const handleParamChange = (e) => {
        const value = e.target.value.toUpperCase().replace(/[^A-Fa-f0-9]/g, '');
        const params = { type, attKey, value };
        lastQueryParamsRef.current = params;
        setParams(params);
    };
    useEffect(() => {
        if (params && selected && params.value !== '') {
            setParamsInParent([
                { key: attKey, value: params.value, predicate: ExpressionFunctionType.CONTAINS },
                { key: 'dailyMessageCount', value: 2, predicate: ComparisonType.GREATER_THAN },
            ], index);
            //
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [params, selected]);
    return (_jsxs(Toolbar, { variant: "dense", children: [children, _jsx(TextField, { value: params?.value ?? '?',
                onChange: handleParamChange,
                onKeyDown: keyPress,
                size: 'small' })] }));
};
